<template>
    <div style="width: 100%;background-color: #fff; clear:both">
        <div class="footerBox">

            <div class="footerContent">
                <div class="footer-left">
                    <div>联系电话</div>
                    <p>{{ webSiteInfo.phone }}</p>
                    <ul>
                        <li @click="goHttp('https://www.yqgxqsc.com/manage/login')">
                            <img src="@/assets/img/footer-icon01.png" alt="管理端">
                            <div>管理端</div>
                        </li>
                        <li>
                            <img src="@/assets/img/footer-icon02.png" alt="">
                            <div>地址：{{ webSiteInfo.address }}</div>
                        </li>
                        <li @click="goHttp('https://www.sxnuoyun.com/')">
                            <img src="@/assets/img/footer-icon03.png" alt="技术支持">
                            <div>技术支持 <img src="../../../assets/img/logo.png" alt=""></div>
                        </li>
                      <!-- <li @click="goMore('/EducationService/index')">
                        <img src="@/assets/img/userPhoto.jpg" alt="管理端">
                        <div>一期人才</div>
                      </li> -->
                    </ul>
                </div>
                <div class="footer-center">

                    <div class="center-top">
                        <!-- <p @click="goMorePolicy(1)">通知公告</p>
                        <div class="partition-line"></div>
                        <p @click="goMorePolicy(2)">政策动态</p> -->
                    </div>
                    <div class="firstLine">
                        <span>主办单位：阳泉高新区科技创新中心</span>
                        <div class="partition-line"></div>
                        <span>©{{ platformName }} 版权所有</span>
                    </div>
                    <!-- <div class="firstLine">
                        <span>地址：{{ webSiteInfo.address }}</span>
                        <span>联系电话：{{ webSiteInfo.phone }}</span>&nbsp;&nbsp;
                        <span style="margin-right: 0;">技术支持：</span>
                        <img src="../../../assets/img/logo.png" @click="goHttp('https://www.sxnuoyun.com/')"/>
                    </div> -->
                    <div class="firstLine">
                        <a target="_blank" href="https://beian.miit.gov.cn/#/Integrated/index">
                            <span>ICP备案号：{{ webSiteInfo.siteArchival }}</span>
                        </a>
                        <div class="partition-line"></div>
                        <!-- <a href="https://beian.mps.gov.cn/#/query/webSearch?code=14031102000348" rel="noreferrer" target="_blank">晋公网安备14031102000348号</a> -->
                        <!-- <a target="_blank" href="https://beian.mps.gov.cn/#/query/webSearch"> -->
                        <a href="https://beian.mps.gov.cn/#/query/webSearch?code=14031102000348" rel="noreferrer" target="_blank">
                            <span><img style="display:inline-block;margin-top: -3px;" width="16" height="16"
                                    src="https://beian.mps.gov.cn/img/head-logo2.4d29d9b1.png" alt=""> 晋公网安备14031102000348号</span>
                        </a>
                        <!--          <span>{{ webSiteInfo.siteCopyRight }}</span>-->
                    </div>
                </div>


                <div class="footer-right">
                    <div class="footCode2">
                        <img class="footEwm" :src="getImg(webSiteInfo.siteBarCode2)"/>
                        <div class="footEwmTitle">科技创新中心</div>
                    </div>
                    <div class="footCode">
                        <img class="footEwm" :src="getImg(webSiteInfo.siteBarCodes)"/>
                        <div class="footEwmTitle">阳泉高新区</div>
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
import {platformName} from "@/config/platformConfig";
import {getWebInfo} from "@/api/homeService";
import {file_service} from "@/api/adminService";

export default {
    name: "LayoutFooter",
    data() {
        return {
            data: '',
            platformName,
            webSiteInfo: {}
        }
    },
    methods: {
        goHttp(url) {
            window.open(url, '_bank')
        },
        getWebInfo() {
            this.getAction({
                url: getWebInfo.detail,
                params: {id: 1}
            }).then(res => {
                this.webSiteInfo = res
            })
        },
        getImg(imgUrl) {
            return file_service.imagesWeb(imgUrl)
        },
        goMorePolicy(type) {
			this.$router.push({
				path: '/notice',
				query: { type: type }
			})
		},
        goMore(url, str, gourl) {
			this.$router.push({ path: url, query: { id: str, gourl: gourl } })
		},
        goMoreNotice(url, str) {
			this.$router.push({ path: url, query: { ...str } })
		}
    },
    mounted() {
        const myData = new Date();
        this.data = myData.getFullYear();
        this.getWebInfo()
    }
}
</script>

<style scoped lang="less">
.footerBox {
    width: 100%;
    background-color: #f0f8ff;

    .footerContent {
        display:flex;
        justify-content:space-between;
        align-items:center;
        position: relative;
        margin: 0 auto;
        padding: 18px 0;
        width: 1200px;
        .footer-left{
            div{
                font-size:14px;
                color:#666;
            }
            p{
                font-size:20px;
                color:#333;
            }
            ul{
                margin-top:10px;
                display:flex;
                li{
                    position: relative;
                    margin-right:6px;
                    display:flex;
                    justify-content:center;
                    align-items:center;
                    width:46px;
                    height:46px;
                    background-color:#e3f2ff;
                    border-radius:50%;
                    cursor: pointer;
                    img{
                        height:20px;
                    }
                    div{
                        padding:10px 20px;
                        position: absolute;
                        top:-50px;
                        display:none;
                        background-color:#fff;
                        white-space:nowrap;
                        font-size:16px;
                        border-radius:4px;
                        box-shadow: 0px 2px 8px 0px rgba(18,93,178,0.1);
                    }
                }
                li:hover{
                    div{
                        display:block;
                    }
                }
            }
        }
        .footer-center{
            .partition-line{
                margin:0 10px;
                width:1px;
                height:10px;
                background-color:#979b9e;
            }
            .center-top{
                margin-bottom:22px;
                display:flex;
                align-items:center;
                p{
                    cursor: pointer;
                }
            }
            .firstLine {
                display:flex;
                align-items:center;
                padding-top:8px;
                font-size: 14px;
                color: #666;

                span:first-child {
                    display: inline-block;
                }

                a {
                    color: #666;
                }


                img {
                    cursor: pointer;
                }
            }

        }

        .footer-right{
            display:flex;
            position: relative;
           img{
            width:84px;
            height:84px;
           }
           .footEwmTitle{
            margin-top:10px;
            font-size: 14px;
             color: #333;
           }
           .footCode2{
            margin-right:20px;
           }
        }


    }
}
</style>
